<template>
  <div v-if="!initLoading" :class="[$setClasses, totalPrice ? '--gap-small' : '']">
    <el-radio-group v-model="modelPayment" :class="$vClass('radio-group')" v-loading="loading">
      <el-collapse v-if="listPaymentsType" :class="$vClass('collapse')" accordion v-model="activeCollapse">
        <el-collapse-item v-if="handleDisplayPaymentType(radioGroup.creditCard)" v-loading="cardLoading"
          data-testid="customer-payment-credit-card"
          :disabled="hasOnlyOnePaymentType || activeCollapse.includes(radioGroup.creditCard)"
          :name="radioGroup.creditCard"
          @click.stop="!hasOnlyOnePaymentType && setActiveCollapse(radioGroup.creditCard)">
          <template #title>
            <el-radio class="u-flex-1" size="large" :disabled="hasOnlyOnePaymentType" :value="radioGroup.creditCard">
              <h3>{{ getPaymentTypeTitle(radioGroup.creditCard) }}</h3>
            </el-radio>
            <div :class="$vClass('cards-payments')">
              <div v-for="img in $tm('payment.listCardsPayment')" :class="$vClass('cards-payments__item')">
                <img :alt="img.name" :class="`${$vClass('cards-payments__img')} ${img.name}`" :src="img.image" />
              </div>
            </div>
          </template>
          <div>
            <list-cards-payment :class="$vClass('collapse__list-cards-payment')" :show-only-default="showOnlyDefault" />
            <nxt-core-toggle :class="!cardsPayment.length ? 'u-margin-top-0' : ''" v-model="modelToggle" :hide-toggle="hideToggle" :init-toggle="toggle"
              data-testid="customer-payment-add-card-toggle"
              :more-text="$t('payment.creditCardPayment.toggle')" :less-text="$t('payment.creditCardPayment.toggle')"
              name="addCreditCard" @toggle="displayToggle($event, 'addCreditCard')">
              <card-payment ref="cardPayment"
                :key="`${toggle}-${hideToggle}-${isCardInfoLoading}`"
                :billing-address="demand?.from_address"
                :class="hasCreditCard ? 'u-margin-top-default' : undefined"
                :cvc-col="{ xs: 10, sm: 10, md: 8, lg: 8 }"
                :expiry-col="{ xs: 14, md: 16, lg: 16 }"
                :hide-card-form="hideCardForm"
                :name-col="{ xs: 24, sm: 24, lg: 24 }"
                :number-col="{ xs: 24, sm: 24, lg: 24 }" hide-label
                source-placeholder="payment.cardPayment.placeholder" suffix-id="-1"
                @payment-authenticated="$emit('payment-authenticated', $event)"
                @payment-error="emit('payment-error', $event)" @token-change="tokenChange"
                @update:loading="updateLoading" />
              <div v-if="hasCreditCard" :class="[$vClass('add-card'), 'u-display-flex u-jc-end']">
                <el-button :disabled="loading" :loading="loading" class="u-color-secondary" link type="primary"
                  @click.stop="saveCard">
                  {{ $t(`payment.creditCardPayment.${hasCreditCard ? 'addOtherCard' : 'addCard'}`) }}
                  <font-awesome-icon :icon="['fal', 'chevron-right']" />
                </el-button>
              </div>
            </nxt-core-toggle>
          </div>
        </el-collapse-item>
        <el-collapse-item v-if="handleDisplayPaymentType(radioGroup.installment)" v-loading="installmentSimulatedPlanLoading"
          :class="$vClass('collapse__installment-plan')"
          :disabled="hasOnlyOnePaymentType || activeCollapse.includes(radioGroup.installment)"
          :name="radioGroup.installment"
          @click.stop="!hasOnlyOnePaymentType && setActiveCollapse(radioGroup.installment)">
          <template #title>
            <el-radio :disabled="hasOnlyOnePaymentType" :value="radioGroup.installment" class="u-flex-1" size="large">
              <h3>{{ getPaymentTypeTitle(radioGroup.installment) }}</h3>
            </el-radio>
            <div>
              <img :alt="$t('payment.installment.name')" :class="[$vClass('cards-payments__img'), 'floa-logo']"
                :src="$t('payment.installment.image')" />
            </div>
          </template>
          <installment-plan v-if="modelPayment === radioGroup.installment" :offer="offer"
            :options-content="installmentOptions"
            :plan-content="installmentOptions?.options?.plan" />
        </el-collapse-item>
        <el-collapse-item v-if="handleDisplayPaymentType(radioGroup.bankTransfer)"
                          :class="[$vClass('collapse__bank-transfer'), !createBankTransfer ? '--padding-0' : '']"
                    :disabled="hasOnlyOnePaymentType || activeCollapse.includes(radioGroup.bankTransfer)" :name="radioGroup.bankTransfer" @click.stop="!hasOnlyOnePaymentType && setActiveCollapse(radioGroup.bankTransfer)">
          <template #title>
            <el-radio :value="radioGroup.bankTransfer" :disabled="hasOnlyOnePaymentType"  class="u-flex-1" size="large">
              <h3>{{ getPaymentTypeTitle(radioGroup.bankTransfer) }}</h3>
            </el-radio>
            <div>
               <img :alt="$t('payment.bankTransfer.name')" :class="[$vClass('cards-payments__img'), 'bank-transfer-logo']"
                :src="$t('payment.bankTransfer.image')" />
            </div>
          </template>
          <checkout-payment v-if="modelPayment === radioGroup.bankTransfer && (createBankTransfer || Object.keys(bankData).length)"
                            :bank-data="bankData"
                            :create-bank-transfer="createBankTransfer"
                            :force-next-button-disabled="forceNextButtonDisabled"
                            :offer="offerConfig || props.offer" />
        </el-collapse-item>
      </el-collapse>
    </el-radio-group>
    <div v-if="content || totalPrice" :class="[$vClass('content'), 'u-flex-1', totalPrice ? '--has-total-price' : '']">
      <div v-if="totalPrice?.title" :class="$vClass('total-price')">
        <div v-if="totalPrice.title" :class="$vClass('total-price__title')" v-html="totalPrice.title"></div>
        <div v-if="totalPrice.arrhes" :class="$vClass('total-price__arrhes')" v-html="totalPrice.arrhes"></div>
        <div :class="$vClass('total-price__solde')" v-html="totalPrice.solde"></div>
      </div>
      <h4 v-if="paymentTypesTitle" class="u-color-success">
        <font-awesome-icon :icon="['fal', 'circle-info']" /> {{ paymentTypesTitle }}
      </h4>
      <div v-if="content" v-html="content"></div>
    </div>
  </div>
  <div v-else v-loading="initLoading"
      :class="$vClass('init-loading')">
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch, useTemplateRef, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useConfigStore, useProfileStore, useDemandStore, useInstallmentStore } from "@/stores";
import CardPayment from "@/utils/components/CardPayment.vue";
import ListCardsPayment from "@/components/profile/payment/ListCardsPayment.vue";
import InstallmentPlan from "@/components/payments/installment/InstallmentPlan.vue";
import { useMoveManager, useMoveManagerProps } from "@/composables/useMoveManager";
import { useRouter } from "vue-router";
import { usePaymentsStore } from "@/stores/paymentsStore";
import type { Offer } from "@/types/Offers";

defineOptions({
  name: "ListPaymentsType",
  nameClassStyle: "list-payments-type",
});

const props = defineProps({
  ...useMoveManagerProps,
  textParams: { type: Object, default: () => ({}) },
  listPaymentsType: { type: Object, required: true },
  bankData: { type: Object, default: () => ({}) },
  createBankTransfer: { type: Boolean, default: false },
  forceNextButtonDisabled: { type: Boolean, default: false },
  fetchPaymentTypesOnMount: { type: Boolean, default: true },
});

const emit = defineEmits([
  "payment-authenticated",
  "payment-error",
  "token-change",
  "update:loading",
  "next-action",
  "init-loading",
]);

const modelPayment = defineModel<string>("payment");
const modelToggle = defineModel<string>("toggle");

const configStore = useConfigStore();
const profileStore = useProfileStore();
const demandStore = useDemandStore();
const installmentStore = useInstallmentStore();
const paymentsStore = usePaymentsStore();
const { installmentSimulatedPlanLoading } = storeToRefs(installmentStore);
const { buttonsDisabled, offer: offerConfig } = storeToRefs(configStore);
const { cardsPayment, isCardInfoLoading, cardLoading } = storeToRefs(profileStore);
const { paymentTypes, paymentTypesConfig, selectedPayment } = storeToRefs(paymentsStore);

const { getTextVersion, demand } = useMoveManager(props, { emit: () => { } });
const cardPaymentRef = useTemplateRef("cardPayment");
const router = useRouter();

const paymentOptions = computed(() => paymentTypesConfig.value || {});
const displayAddCard = computed(() =>
  typeof paymentOptions.value.displayAddCard === "boolean"
    ? paymentOptions.value.displayAddCard
    : true,
);
const showOnlyDefault = computed(() => !!paymentOptions.value.showOnlyDefault);
const hasCreditCard = computed(() => !!cardsPayment.value?.length);
const toggle = computed(() => modelToggle.value === "addCreditCard");
const paymentTypesTitle = computed(() =>
  getTextVersion(paymentOptions.value?.paymentTypesTitle || '', props.textParams),
);
const onlyOnePaymentType = computed(() => Object.keys(props.listPaymentsType).length === 1 ? Object.keys(props.listPaymentsType)[0] : '');
const hasOnlyOnePaymentType = computed(() => !!onlyOnePaymentType.value);
const content = computed(() =>
  getTextVersion(
    props.listPaymentsType?.[modelPayment.value ?? ""]?.options?.content,
    props.textParams,
  ),
);

const installmentOptions = computed(() => paymentOptions.value?.paymentTypes?.installment);

const totalPrice = computed(() => {
  if (paymentOptions.value?.totalPrice) {
    return {
      title: getTextVersion(paymentOptions.value.totalPrice.title, props.textParams),
      content: getTextVersion(paymentOptions.value.totalPrice.content || '', props.textParams),
      arrhes: getTextVersion(paymentOptions.value.totalPrice.arrhes, props.textParams),
      solde: getTextVersion(paymentOptions.value.totalPrice.solde, props.textParams),
    };
  }
  return null;
});

const initLoading = ref(true);
const loading = ref(true);
const manuallySavedCard = ref(false);
const radioGroup = ref({
  creditCard: "creditCard",
  installment: "installment",
  bankTransfer: "bankTransfer",
});

const activeCollapse = computed({
  get: () => (modelPayment.value ? [modelPayment.value] : []),
  set: (value: string[]) => (modelPayment.value = value?.[0] ?? ""),
});

const hideCardForm = computed(() => !toggle.value || isCardInfoLoading.value || !displayAddCard.value);
const hideToggle = computed(() => !hasCreditCard.value || isCardInfoLoading.value || !displayAddCard.value);

watch(
  hasCreditCard,
  (hasCard) => {
    modelToggle.value = hasCard ? "" : "addCreditCard";
  },
);

const getPaymentTypeTitle = (type: string) =>
  getTextVersion(props.listPaymentsType?.[type]?.options?.title, props.textParams);

const setActiveCollapse = (value: string) => {
  activeCollapse.value = [value];
  modelPayment.value = value;
  selectedPayment.value = value;
};

const displayToggle = (value: boolean, name: string) => {
  modelToggle.value = value ? name : "";
};

const saveCard = async () => {
  try {
    buttonsDisabled.value = true;
    loading.value = true;
    manuallySavedCard.value = true;
    await cardPaymentRef.value.submitFormToCreateToken();
  } catch (error) {
    loading.value = false;
    buttonsDisabled.value = false;
  }
};

const updateLoading = (value: boolean) => {
  emit("update:loading", value);
  loading.value = value;
  buttonsDisabled.value = value;
};

const addCreditCard = async (value: string) => {
  try {
    await demandStore.postCardToken({
      stripe_intent_id: value,
      is_default: !cardsPayment.value?.length,
    });
  } catch (error) {
    loading.value = false;
  } finally {
    modelToggle.value = "";
    loading.value = false;
  }
};

const tokenChange = async (value: string) => {
  if (hasCreditCard.value && manuallySavedCard.value) {
    manuallySavedCard.value = false;
    await addCreditCard(value);
    await profileStore.getCardsPayment();
  } else {
    manuallySavedCard.value = false;
    emit("token-change", value);
  }
  buttonsDisabled.value = false;
};

const resetState = () => {
  loading.value = false;
  cardLoading.value = false;
  buttonsDisabled.value = false;
};

const handleDisplayPaymentType = (type: string) => {
  return !!props.listPaymentsType?.[type];
};

onMounted(async () => {
  try {
    buttonsDisabled.value = true;
    emit('init-loading', true);
    if (props.fetchPaymentTypesOnMount && offerConfig.value) {
      await paymentsStore.getPaymentTypes(offerConfig.value);
    }
    if (demand.value?.stripe_registered && (!hasOnlyOnePaymentType.value || onlyOnePaymentType.value === 'creditCard')) {
      await profileStore.getCardsPayment();
    }
  } catch (error) {
    loading.value = false;
  } finally {
    if (props.fetchPaymentTypesOnMount && paymentTypes.value.length === 0) {
      router.push({ name: 'comparator' }).catch(() => {
        loading.value = false;
      }).finally(() => {
        resetState();
        initLoading.value = false;
        emit('init-loading', false);
      });
      return;
    }
    modelToggle.value = ((onlyOnePaymentType.value && onlyOnePaymentType.value !== 'creditCard') || cardsPayment.value?.length) ? "" : "addCreditCard";
    const hasValidSelectedPayment = !!(modelPayment.value && paymentTypes.value && paymentTypes.value.some(type => type === modelPayment.value));
    if (!hasValidSelectedPayment) {
      modelPayment.value = hasOnlyOnePaymentType.value
        ? onlyOnePaymentType.value
        : (handleDisplayPaymentType(radioGroup.value.bankTransfer) && !cardsPayment.value?.length && Object.keys(props.bankData).length)
          ? "bankTransfer"
          : "creditCard";
    }
    resetState();
    initLoading.value = false;
    emit('init-loading', false);
  }
});

defineExpose({
  cardPayment: cardPaymentRef,
});
</script>

<style scoped lang="scss">
.list-payments-type {
  --payment-wrapper-font-size: var(--nxt-font-size-small);
  --payment-cards-payment-item-width: 25px;

  display: flex;
  flex-direction: column;
  gap: 20px;

  &__init-loading {
    min-height: 350px;
  }

  @include breakpoint(tablet) {
    --payment-wrapper-font-size: var(--nxt-font-size-medium);
    --payment-cards-payment-item-width: 40px;

    flex-direction: row;
    gap: 40px;
  }

  @include breakpoint(desktop) {
    gap: 80px;

    &.--gap-small {
      gap: 20px;
    }
  }

  &__radio-group :deep(.el-radio__inner),
  &__cards-payments {
    margin-block-start: 0.6em;
    margin-block-end: 0.6em;
  }

  &__radio-group {
    display: block;
    border-left: 1px solid var(--el-border-color-lighter);
    border-right: 1px solid var(--el-border-color-lighter);
    border-top: 1px solid var(--el-border-color-lighter);

    :deep(.el-radio__label) {
      text-wrap: initial;
    }

    @include breakpoint(tablet) {
      width: 60%;
      border: none;
    }

    @include breakpoint(desktop) {
      width: 52%;
    }
  }

  &>div,
  :deep(h3) {
    font-size: var(--payment-wrapper-font-size);
  }

  &__content {
    border: 1px solid var(--el-border-color-lighter);
    padding: 10px;

    :deep(ul) {
      padding-inline-start: 25px;
    }

    @include breakpoint(tablet) {
      flex: 1;
      border: none;
      padding: 0;
    }
  }

  &__cards-payments {
    display: flex;
    gap: 3px;

    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: var(--payment-cards-payment-item-width);
      border: 1px solid var(--el-border-color-lighter);
      padding: 3px 0;
      border-radius: 5px;
    }

    &__img {
      height: 10px;

      &.visa {
        height: 8px;
      }

      &.floa-logo,
      &.bank-transfer-logo {
        height: 20px;
      }

      @include breakpoint(tablet) {
        height: 15px;

        &.visa {
          height: 10px;
        }
      }
    }
  }

  &__add-card {
    margin-top: var(--nxt-space-small);

    .el-button {
      box-shadow: none;
      text-transform: initial;
    }
  }

  .--margin-bottom-0 {
    margin-bottom: 0;
  }

  :deep(.payment) {
    form {
      .el-row {
        row-gap: 10px;
      }
    }

    .payment {
      &__expiry {
        padding-right: 0 !important;

        &>div {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }

      &__cvc {
        padding-left: 0 !important;

        &>div {
          border-left: none;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }

      &__help-block {
        position: absolute;
        bottom: -2px;
        left: 10px;
        margin-top: 0;
        font-size: var(--nxt-font-size-small);
      }

      &__cvc {
        .payment__help-block {
          left: 0;
        }
      }
    }

    .el-col {
      position: relative;

      .el-input__inner {
        height: 45px;
      }
    }
  }

  &__add-card {
    margin-top: var(--nxt-space-small);

    .el-button {
      box-shadow: none;
      text-transform: initial;
    }
  }

  &__panel {
    display: flex;
    flex-direction: column;
    padding: 0;
    background-color: var(--nxt-color-light-grey);

    @include breakpoint(mobile) {
      flex-direction: row;
    }

    &__img {
      margin: 20px auto;
    }

    &__text {
      margin: 0;
      flex: 1 1 auto;
      text-align: center;

      @include breakpoint(mobile) {
        text-align: left;
      }
    }
  }

  &__collapse {
    border: none;

    :deep(.toggle) {
      .toggle {
        &__text {
          margin-bottom: 0;
        }

        &__more {
          flex-direction: row-reverse;
        }

        &__more,
        &__less {
          display: flex;
          gap: var(--nxt-space-xxsmall);
          align-items: center;
          justify-content: left;
          text-align: left;
          padding-left: var(--nxt-space-xxsmall);

          svg {
            font-size: 20px;
          }
        }
      }
    }

    :deep(.el-collapse-item) {
      h3 {
        margin-block-start: 0.6em;
        font-family: sans-serif;
        font-weight: normal;
      }

      .el-collapse-item {
        &__content {
          padding-left: var(--nxt-space-default);
          padding-right: var(--nxt-space-default);
          max-width: 565px;

          @include breakpoint(tablet) {
            padding-left: 30px;

            .installment-plan {

              &__container {
                padding-left: 22px;
              }
            }
          }
        }

        &__title {
          line-height: normal;
          padding-left: var(--nxt-space-xxsmall);

          label {
            margin-right: var(--nxt-space-xxxsmall);
          }
        }

        &.is-disabled {
          .el-collapse-item__header {
            display: none;
          }
        }

        &__arrow {
          display: none;
        }
      }
    }

    @include breakpoint(tablet) {
      :deep(.el-collapse-item:last-child) {

        .el-collapse-item__header,
        .el-collapse-item__wrap {
          border-bottom: none;
        }
      }
    }
  }

  &__wrapper {
    padding: {
      top: 20px;
      bottom: 20px;
    }
  }


  &__content.--has-total-price {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__total-price {
    display: grid;
    width: 100%;
    max-width: 400px;
    height: auto;
    row-gap: var(--nxt-space-large);

    :deep(span),
    :deep(p) {
      font-size: 21px;
    }

    :deep(p) {
      margin-block: 0;
    }

    &__title {

      .el-radio {
        margin: 0;
      }
    }

    &__arrhes,
    &__solde,
    &__title {
      display: grid;
      row-gap: var(--nxt-space-large);
      grid-template-columns: 1fr minmax(125px, max-content);
      column-gap: var(--nxt-space-small);
      position: relative;

      :deep(.--item__after) {
        text-align: right;

        i {
          font-size: 13px;
          display: block;
          position: absolute;
          right: 0;
        }
      }

      :deep(p) {
        margin-bottom: 0;
      }

      :deep(.--max-width) {
        max-width: 125px;
      }

      @include breakpoint(tablet) {
        margin-bottom: 0;
      }
    }

    &__solde {
      padding-bottom: 15px;
    }

    @include breakpoint(tablet) {
      margin-top: var(--nxt-space-default);
      padding: var(--nxt-space-small) var(--nxt-space-default);
      border: var(--nxt-color-tab-border) solid 2px;
      border-radius: var(--nxt-border-radius-base);
    }
  }
}
</style>
